export default ((value, args) => {
  return value.trim().search(' ') > 0;
})